module.exports = __webpack_public_path__ + "static/ui-3-347f9e3f19da652cec4d46f1f71a8d7c.png";